import { atom } from "recoil";
import { User, Columns, Filters } from "../components/types/user";

export const columnState = atom({
  key: "columnState",
  default: <any>[],
});
export const columnOrderState = atom({
  key: "columnOrderState",
  default: <Array<string> | Array<any>>[],
});

export const columnVisibilityState = atom({
  key: "columnVisibilityState",
  default: <Record<string, boolean>>{},
});
